// fonts.js
import { IRANSansXDemiBold } from './IRANSansXDemiBold';
export const iranSans = {
  IRANSans: {
    normal: IRANSansXDemiBold, // محتوای base64 فونت
    bold: IRANSansXDemiBold,
    italics: IRANSansXDemiBold,
    bolditalics: IRANSansXDemiBold,
  },
};
